export default function GetAmericoHealthClass(value) {
    switch (value) {
        case "R":
        case "RP":
            return "good";
        case "P":
            return "better";
        case "PP":
            return "best";
        default:
            return "";
    }
}


// WEBPACK FOOTER //
// ./src/components/Quoters/MCT/Helpers/GetAmericoHealthClass.js